const { REACT_APP_NUMBER_COURSE_PER_PAGE, REACT_APP_BASE_BACKEND_URL} = process.env;

export const getNumberOfPage = (numberOfItems)=>{
    return Math.ceil(numberOfItems/REACT_APP_NUMBER_COURSE_PER_PAGE);
};

export const getCourseRender = (courses, PageIndex) =>{
    const startIndex = PageIndex*REACT_APP_NUMBER_COURSE_PER_PAGE;
    const endIndex = (PageIndex+1)*REACT_APP_NUMBER_COURSE_PER_PAGE;
    return courses.slice(startIndex, endIndex);
};

export const stringToPascalCase = (string) => {
    let words = string.match(/[a-zA-Z0-9]+/g);
    if (!words) return '';
    let exportString = '';
    for(let word of words){
        exportString = exportString + ' ' + word.replace(/[a-zA-Z]/, (w) => w.toUpperCase());
    }
    return exportString
};
